import React from 'react';
import PublishingMetadataField from './Field/component';

export function DescriptionField() {
  return (
    <PublishingMetadataField
      label="Description"
      fieldName="description"
      multiline
      rows={3}
    />
  );
}
